module.exports = __webpack_public_path__ + "img/zhuanke1.ba386139.png";